<ng-container *ngIf="phxImplementation; else hierarchyMultiSelectRef">
  <phx-select
    *ngIf="!showMobileView"
    [phxPlaceholder]="placeholder"
    [phxOpen]="isDropdownOpen"
    [phxMultiple]="true"
    [disabled]="isDisabled"
    [phxShowSearch]="true"
    [phxLoading]="isLoading"
    [phxOptions]="options"
    [phxShowCounter]="showCounter"
    [phxDropdownWidth]="dropdownWidth"
    [phxDropdownClassName]="overlayClassName"
    [phxPlacement]="placement"
    [phxTriggerTemplate]="customTriggerButtonTemplate && triggerTemplateRef"
    [phxLabelTemplate]="customLabelTemplate && labelTemplateRef"
    [ngModel]="selectedOptions"
    [phxSelectionChangeDebounceTime]="debounceTime"
    [phxEmitOnlyIndependentSelections]="true"
    (phxSelectionChange)="onPhoenixSelectChange($event)"
    (phxOpenChange)="onDropdownOpenChange($event)"
  >
  </phx-select>
  <phx-mobile-select
    *ngIf="showMobileView"
    phxPlacement="left"
    [phxPlaceholder]="placeholder"
    [phxOpen]="dialogOpen"
    [phxMultiple]="true"
    [disabled]="isDisabled"
    [phxShowSearch]="false"
    [phxShowCounter]="showCounter"
    [phxLoading]="isLoading"
    [phxOptions]="options"
    [phxDropdownWidth]="dropdownWidth"
    [phxDropdownClassName]="overlayClassName"
    [phxTriggerTemplate]="customTriggerButtonTemplate && triggerTemplateRef"
    [phxLabelTemplate]="customLabelTemplate && labelTemplateRef"
    [ngModel]="selectedOptions"
    [phxSelectionChangeDebounceTime]="debounceTime"
    [phxEmitOnlyIndependentSelections]="true"
    (phxSelectionChange)="onPhoenixSelectChange($event)"
    (phxOpenChange)="onDialogOpenChange($event)"
  >
  </phx-mobile-select>
</ng-container>

<ng-template #labelTemplateRef let-selectedItems>
  <ng-container
    [ngTemplateOutlet]="customLabelTemplate"
    [ngTemplateOutletContext]="{
      $implicit: {
        isOpen: isDropdownOpen,
        selectedItems: selectedItems,
        selectedSize: selectedItems?.length
      }
    }"
  ></ng-container>
</ng-template>

<ng-template #triggerTemplateRef let-selectedItems>
  <ng-container
    [ngTemplateOutlet]="customTriggerButtonTemplate"
    [ngTemplateOutletContext]="{
      $implicit: {
        isOpen: isDropdownOpen,
        selectedItems: selectedItems,
        selectedSize: selectedItems?.length
      }
    }"
  ></ng-container>
</ng-template>

<ng-template #hierarchyMultiSelectRef>
  <hierarchy-multi-select-with-counter
    [prefixIconTemplate]="showPrefixIcon ? prefixIconTemplate : undefined"
    [isDisabled]="isDisabled"
    [disabledTooltipMessage]="disabledTooltipMessage"
    [prefixIconOnly]="!expandGroupsFilter"
    [placeholder]="placeholder"
    [condensedMessage]="condensedMessage"
    [isLoading]="isLoading"
    [options]="options$ | async"
    [alwaysShowCondensedMessage]="alwaysShowCondensedMessage"
    [footerThreshold]="footerThreshold"
    [dialogOpen]="dialogOpen"
    [canSearchOptions]="true"
    [fullWidth]="fullWidth"
    [formVariant]="formVariant"
    class="d-block"
    (update)="onSelectedGroupsUpdate($event)"
    (dialogClose)="onDialogClose()"
    (dropDownClose)="onDropDownClose()"
    [customTriggerButtonTemplate]="customTriggerButtonTemplate"
    [overlayClassName]="overlayClassName"
  >
  </hierarchy-multi-select-with-counter>
</ng-template>

<ng-template #prefixIconTemplate>
  <i phx-icon [phxIcon]="PersonGroupIcon"></i>
</ng-template>
